export enum MarketType {

  /**
   * Aquarium.
   */
  AQ,

  /**
   * Non-Aquarium.
   */
  NAQ

}

export namespace MarketType {

  export function fromString(name: string): MarketType {
    return MarketType[name];
  }

}

